import React, { useEffect, useState } from "react";

const BrowserCheck = ({ onBrowserDetect }) => {
  const [isChrome, setIsChrome] = useState(true);

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isChromeBrowser = /chrome/.test(userAgent) && !/edge|edg|opera/.test(userAgent);
    setIsChrome(isChromeBrowser);
    console.log("is chrome browser" + isChromeBrowser);
    if (onBrowserDetect) {
      onBrowserDetect(isChromeBrowser); // notify parent
    }
  }, []);

  return (
    <div style={{marginLeft:"auto", marginRight: "10px"}}>
      {!isChrome && (
        <div>
          Best viewed on Google Chrome 
        </div>
      )}
    </div>
  );
};

export default BrowserCheck;
